import React, { FC } from 'react';

import { IconProps } from '../../types/icon.types';

export const CloseCrossBtn: FC<IconProps> = ({
  width = 24,
  height = 24,
  className,
}) => (
  <svg
    className={`cursor-pointer ${className}`}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
      stroke="#2C3038"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
